export const INVOICE_STATUS = {
  READY: 'ready',
  PAID: 'paid',
} as const;

export type InvoiceStatus = (typeof INVOICE_STATUS)[keyof typeof INVOICE_STATUS];

export const INVOICE_TABS = {
  PENDING: 'Facturas pendientes',
  PAID: 'Facturas pagadas',
  PALOMMA_PLUS: 'Palomma Plus',
} as const;

export type InvoiceTab = (typeof INVOICE_TABS)[keyof typeof INVOICE_TABS];
